import { BlogPostAttributesFragment, GqlOps } from "#gql";

import type { Ref } from "vue";

export function useNews(query: GqlOps, start: Ref<number>, limit: Ref<number>, locale: Ref<string>) {
  const error = ref(null);
  const loading = ref(true);
  const data = ref<BlogPostAttributesFragment[]>([]);
  const hasMore = ref(false);

  async function doQuery() {
    error.value = null;
    loading.value = true;

    const { data: queryData, error: queryError } = await useAsyncGql(query as "BlogPosts", {
      start: start.value,
      limit: limit.value,
      locale: locale.value,
    });

    if (
      queryData.value?.blogPosts?.meta?.pagination.pageCount === queryData.value?.blogPosts?.meta?.pagination.page ||
      (queryData.value?.blogPosts?.meta?.pagination?.total &&
        queryData.value?.blogPosts?.meta?.pagination?.pageSize &&
        queryData.value?.blogPosts?.meta?.pagination?.total <= queryData.value?.blogPosts?.meta?.pagination?.pageSize)
    ) {
      hasMore.value = false;
    } else {
      hasMore.value = true;
    }

    loading.value = false;

    if (queryData.value && queryData.value.blogPosts?.data) {
      data.value = [...data.value, ...queryData.value?.blogPosts?.data];
    }

    error.value = queryError.value;
  }

  /**
   *  if start or pageSize is a ref, watch for changes so we can re-run the query when they change
   *  else just run the query once
   */

  if (isRef(start)) {
    watchEffect(() => doQuery());
  } else {
    doQuery();
  }

  return { data, error, loading, hasMore };
}
